'use client'
import React, { useState } from 'react'

import { ChangeHandler } from 'react-hook-form'

export interface FormRadioFieldProps extends React.HTMLAttributes<HTMLInputElement> {
    label?: string
    id?: string
    name?: string
    value?: string | number
    checked?: boolean
    disabled?: boolean
    readOnly?: boolean
    onChange?: ChangeHandler | ((value?: unknown) => void)
    onBlur?: ChangeHandler
    boxed?: boolean
}

export const FormRadioField = React.forwardRef<HTMLInputElement, FormRadioFieldProps>(
    ({ label, id, name, value, checked, disabled, readOnly, onChange, onBlur, boxed, ...rest }, ref) => {
        const [checkedValue, setCheckedValue] = useState(checked)

        const onChangeHandler = () => {
            if (!readOnly && !disabled) {
                setCheckedValue(!checkedValue)
            }
        }

        const labelClasses = `
            ${boxed ? 'radio--boxed' : ''}
            ${disabled ? 'radio--disabled' : ''}
            ${readOnly ? 'radio--readonly' : ''}
        `

        return (
            <label className={`radio ${labelClasses}`} data-cy={`input-radio-option__value-${value}__label-${label}`}>
                <input
                    {...rest}
                    ref={ref}
                    type="radio"
                    id={id}
                    name={name}
                    value={value}
                    disabled={disabled || (readOnly && !checked)}
                    className="radio__input"
                    onChange={(e) => {
                        onChange && onChange(e)
                        onChangeHandler()
                    }}
                    onKeyDown={(e) => {
                        if (e.key === 'Space') {
                            onChange && onChange(e)
                            onChangeHandler()
                        }
                    }}
                    onBlur={(e) => {
                        onBlur && onBlur(e)
                    }}
                    defaultChecked={checkedValue}
                />
                {label && <span className="radio__label">{label}</span>}
            </label>
        )
    },
)
